const isLive = window.location.hostname !== 'localhost';

module.exports = {
  cloudFunctionsUrl: isLive ? 'https://us-central1-bekbakes-1111.cloudfunctions.net' : 'http://localhost:5001/bekbakes-1111/us-central1',
  firebase: {
    apiKey: 'AIzaSyDi0y4_Ih0hlVe3sBuutT3jLh0MK0MWaKk',
    authDomain: 'bekbakes-1111.firebaseapp.com',
    databaseURL: 'https://bekbakes-1111.firebaseio.com/',
    projectId: 'bekbakes-1111',
    storageBucket: 'bekbakes-1111.appspot.com'
  }
}



//////////////////
// WEBPACK FOOTER
// ./application-config.js
// module id = 46
// module chunks = 4